import { Button } from '@warp-ds/react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { parseUrl } from '@/scenes/resultPage/helpers';
import styles from './TopBarMap.module.css';

type TopBarMapProps = {
    toggleFilterState: () => void;
    filtersOpen: boolean;
};

export const TopBarMapMobile = ({ toggleFilterState, filtersOpen }: TopBarMapProps) => {
    const router = useRouter();
    const searchParams = parseUrl(router.query);

    return (
        <div className={cn(styles.topbarMapMobile, 'md:hidden grid grid-cols-2 p-8 items-center border-b fixed left-0 right-0 bg-white')}>
            {filtersOpen ? (
                <div />
            ) : (
                <Button small href={`${router.basePath}/resultat/?${searchParams.toString()}`} data-testid="closeMapButton">
                    Lukk kart
                </Button>
            )}
            <Button small className="ml-auto" primary={filtersOpen} onClick={toggleFilterState} data-testid="showFilterButton">
                {filtersOpen ? 'Vis resultat' : 'Vis filter'}
            </Button>
        </div>
    );
};
